export enum COMMENT_FILTER {
  ALL = 'all',
  UNRESOLVED = 'unresolved',
  ATTACHMENTS = 'attachments',
  MENTIONS = 'mentions',
}

export type LiveblocksState = {
  isCommentingMode: boolean;
  centerCommentRequested: number;
  showCommentThreads: boolean;
  commentFilter: COMMENT_FILTER;
  openComments: string[];
  targetThreadId: string | null;
};
